// /opt/isp_erp/frontend/src/api/finanzas/finanzas.api.js
import api from '../axios';

export const finanzasAPI = {
  // Dashboard financiero
  getDashboardFinanciero: (año, mes) => 
    api.get('/finanzas/dashboard/financiero', { params: { año, mes } }),

  // Exportar reportes
  exportarFacturas: (params) => 
    api.get('/finanzas/reportes/facturas', { params, responseType: 'blob' }),
  
  exportarPagos: (params) => 
    api.get('/finanzas/reportes/pagos', { params, responseType: 'blob' }),

  // ======================================================
  // SUCURSALES
  // ======================================================
  getSucursales: () => api.get('/finanzas/reportes/sucursales'),
  crearSucursal: (data) => api.post('/finanzas/reportes/sucursales', data),
  actualizarSucursal: (id, data) => api.put(`/finanzas/reportes/sucursales/${id}`, data),
  eliminarSucursal: (id) => api.delete(`/finanzas/reportes/sucursales/${id}`),

  // ======================================================
  // PUNTOS DE COBRO
  // ======================================================
  getPuntosCobro: (sucursalId) => api.get('/finanzas/reportes/puntos-cobro', { params: { sucursal_id: sucursalId } }),
  crearPuntoCobro: (data) => api.post('/finanzas/reportes/puntos-cobro', data),
  actualizarPuntoCobro: (id, data) => api.put(`/finanzas/reportes/puntos-cobro/${id}`, data),
  eliminarPuntoCobro: (id) => api.delete(`/finanzas/reportes/puntos-cobro/${id}`),

  // ======================================================
  // CUENTAS BANCARIAS
  // ======================================================
  getCuentasBancarias: (sucursalId) => api.get('/finanzas/reportes/cuentas-bancarias', { params: { sucursal_id: sucursalId } }),
  crearCuentaBancaria: (data) => api.post('/finanzas/reportes/cuentas-bancarias', data),
  actualizarCuentaBancaria: (id, data) => api.put(`/finanzas/reportes/cuentas-bancarias/${id}`, data),
  eliminarCuentaBancaria: (id) => api.delete(`/finanzas/reportes/cuentas-bancarias/${id}`),

  // ======================================================
  // REPORTES
  // ======================================================
  getReporteCobrosDiario: (params) => api.get('/finanzas/reportes/cobros-diario', { params }),
  getReporteCobrosMensual: (params) => api.get('/finanzas/reportes/cobros-mensual', { params }),
  getResumenSucursales: () => api.get('/finanzas/reportes/resumen-sucursales'),
  getReporteCobrosPorRango: (params) => api.get('/finanzas/reportes/cobros-por-rango', { params }),

  // ======================================================
  // EXPORTAR REPORTE A PDF
  // ======================================================
  exportarReportePDF: (params) => api.get('/finanzas/reportes/cobros-diario/exportar', {
    params,
    responseType: 'blob'
  }),

 // Exportar reporte mensual a PDF
  exportarReporteMensualPDF: (params) => api.get('/finanzas/reportes/cobros-mensual/exportar', {
    params,
    responseType: 'blob'
  }),

  // Exportar PDF del rango
  exportarReporteRangoPDF: (params) => api.get('/finanzas/reportes/cobros-por-rango/exportar', {
    params,
    responseType: 'blob'
  }),
};
